import React from "react";
import { Document, Page, Text, View, StyleSheet ,Image} from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: { padding: 30, fontSize: 12, fontFamily: "Helvetica", color: "#101828" },
  heading: {
    textAlign: "center",
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 20,
    color: "#003149",
  },
  recordGroup: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    borderBottomStyle: "solid",
  },
  row: { flexDirection: "row", justifyContent: "space-between", marginBottom: 6 },
  label: { color: "#344054", fontWeight: "bold" },
  value: { color: "#101828" },
});

const ExportUnvalidatedPunchesPDF = ({ data,logo }) => {
  const { t } = useTranslation(); // ← FIX IS HERE

  return (
    <Document>
      <Page size="A4" style={styles.page}>

    {logo && (
          <Image
            src={logo}
            style={{ width: 120, alignSelf: "center", marginBottom: 10 }}
          />
        )}
        <Text style={styles.heading}>
          {t("unvalidatedPunches.title")}
        </Text>

        {data.map((row, i) => (
          <View key={i} style={styles.recordGroup}>

            <View style={styles.row}>
              <Text style={styles.label}>{t("unvalidatedPunches.tableHeaders.id")}:</Text>
              <Text style={styles.value}>{row.id}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("unvalidatedPunches.tableHeaders.fullName")}:</Text>
              <Text style={styles.value}>{row.fullName}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("unvalidatedPunches.tableHeaders.email")}:</Text>
              <Text style={styles.value}>{row.email}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("unvalidatedPunches.tableHeaders.date")}:</Text>
              <Text style={styles.value}>{row.date}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("unvalidatedPunches.tableHeaders.checkIn")}:</Text>
              <Text style={styles.value}>{row.checkIn}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("unvalidatedPunches.tableHeaders.checkOut")}:</Text>
              <Text style={styles.value}>{row.checkOut}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("unvalidatedPunches.tableHeaders.location")}:</Text>
              <Text style={styles.value}>{row.location}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("unvalidatedPunches.tableHeaders.details")}:</Text>
              <Text style={styles.value}>{row.details}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("unvalidatedPunches.tableHeaders.reviewNote")}:</Text>
              <Text style={styles.value}>{row.reviewNote}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("unvalidatedPunches.tableHeaders.status")}:</Text>
              <Text style={styles.value}>{row.status}</Text>
            </View>

          </View>
        ))}

      </Page>
    </Document>
  );
};

export default ExportUnvalidatedPunchesPDF;
